import { render, staticRenderFns } from "./Navbarbooks.vue?vue&type=template&id=66f2826b&"
import script from "./Navbarbooks.vue?vue&type=script&lang=js&"
export * from "./Navbarbooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports